import { render, staticRenderFns } from "./MapboxLegend.vue?vue&type=template&id=cc3d7b22"
import script from "./MapboxLegend.vue?vue&type=script&lang=js"
export * from "./MapboxLegend.vue?vue&type=script&lang=js"
import style0 from "./MapboxLegend.vue?vue&type=style&index=0&id=cc3d7b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports